import {PIXI} from '@colonist/pixi'
import {UIGameEndChartView} from './UIGameEndChartView'
import {CardDataController} from '@colonist/game-card-types'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {CardView} from '../../ui_canvas_engine/CardView'
import {GameEndChartColumnData} from './UIGameEndChartColumnView'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'
import {GameModeTranslationKeyContext} from '@colonist/i18n'
import {CARD_TIP_TITLE} from '@colonist/ui-game'

export class GameEndStatsDevCardStatsView extends UIGameEndChartView {
    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, devCards: CardEnum[], activeDevelopmentCardTypes: CardTypeEnum[], gameModeTranslationKeyContext: GameModeTranslationKeyContext) {
        super(x, y, w, h, container, CardDataController.getCardEnumsOfTypes(activeDevelopmentCardTypes).length, {
            key: 'strings:game.endGame.devCards.cardsDrawn',
            options: {
                context: gameModeTranslationKeyContext,
            },
        })

        this.createDevCardStats(devCards, activeDevelopmentCardTypes)
        this.drawChart()
    }

    private createDevCardStats(allDevelopmentCards: CardEnum[], activeDevelopmentCardTypes: CardTypeEnum[]) {
        const activeDevelopmentCards = CardDataController.getCardEnumsOfTypes(activeDevelopmentCardTypes)

        for(const developmentCard of activeDevelopmentCards) {
            const cardData = CardDataController.getCardDataForCard(developmentCard)
            if(cardData == undefined) continue
            const columnData: GameEndChartColumnData = {
                label: CARD_TIP_TITLE[developmentCard],
                amount: ArrayUtils.countOccurenceOfValueInArray(allDevelopmentCards, developmentCard),
                texture: CardView.getTextureForCard(developmentCard),
            }
            this.columnDataArray.push(columnData)
        }
    }
}
